/**
 * Champions Dashboard - Feedback Collection Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/feedback
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { FeedbackCollection } from '../../components/champions/dashboard/FeedbackCollection';

export function ChampionsFeedbackPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <FeedbackCollection />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsFeedbackPage;
